import './index.scss';

import ReactDOM from 'react-dom/client';
import { InteractionType, PublicClientApplication } from "@azure/msal-browser";
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';
import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";

import { BookmarkAdd } from "./routes/bookmarkAdd";
import { Bookmarks } from "./routes/bookmarks";
import { Categories } from "./routes/categories";
import { CategoryAdd } from "./routes/categoriesAdd";
import { Error } from "./routes/error";
import { Home } from "./routes/home";
import { VideoAdd } from "./routes/videoAdd";
import { VideoBulkAdd } from './routes/videoBulkAdd';
import { VideoEdit } from "./routes/videoEdit";
import { BookmarkBulkAdd } from './routes/bookmarkBulkAdd';
import { BookmarkEdit } from "./routes/bookmarkEdit";
import { Search } from "./routes/search";
import { QuickAdd } from "./routes/quickAdd";
import { QuickAddProvider } from "./contexts/QuickAddContext";

import { msalClientId } from "./constants";
import reportWebVitals from './reportWebVitals';
import { Tags } from './routes/tags';
import { Backup } from "./routes/backup";
import { Cleanup } from "./routes/cleanup";
import { AppSpinner } from './components/appSpinner';

import { ThemeProvider } from './contexts/ThemeContext';

const pca = new PublicClientApplication({
    auth: {
        clientId: msalClientId,
        authority: 'https://login.microsoftonline.com/7cc1b8c0-297e-4d5f-a6e0-e5f7518d3e4e',
        redirectUri: window.location.origin, // Ensure this matches a registered redirect URI in Azure
    },
});

const router = createBrowserRouter([
    {
        path: "/",
        element: <Home/>,
        errorElement: <Error/>
    },
    {
        path: "/backup",
        element: <Backup/>
    },
    {
        path: "/cleanup",
        element: <Cleanup/>
    },
    {
        path: "/pending-deletion",
        element: <Navigate to="/cleanup" replace/>
    },
    {
        path: "/deleted-videos",
        element: <Navigate to="/cleanup" replace/>
    },
    {
        path: "/bookmarks/add",
        element: <BookmarkAdd/>
    },
    {
        path: "/bookmarks",
        element: <Bookmarks/>
    },
    {
        path: "/bookmarks/:id/edit",
        element: <BookmarkEdit/>
    },
    {
        path: "/bookmarks/add/bulk",
        element: <BookmarkBulkAdd/>
    },
    {
        path: "/categories/add",
        element: <CategoryAdd/>
    },
    {
        path: "/categories",
        element: <Categories/>
    },
    {
        path: "/tags",
        element: <Tags/>
    },
    {
        path: "/videos/add/bulk",
        element: <VideoBulkAdd/>
    },
    {
        path: "/videos/add",
        element: <VideoAdd/>
    },
    {
        path: "/videos/:id/edit",
        element: <VideoEdit/>
    },
    {
        path: "/quick-add",
        element: <QuickAdd/>
    },
    {
        path: "/search",
        element: <Search/>
    },
]);

const LoadingComponent = () => {
    return (
        <div className="d-flex flex-column justify-content-center align-items-center vh-100 text-light bg-dark">
            <AppSpinner />
            <p className="mt-2 fs-4">Authenticating...</p>
        </div>
    );
};

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <MsalProvider instance={pca}>
        <MsalAuthenticationTemplate
            interactionType={InteractionType.Redirect}
            loadingComponent={LoadingComponent}
        >
            <ThemeProvider>
                <QuickAddProvider>
                    <RouterProvider router={router}/>
                </QuickAddProvider>
            </ThemeProvider>
        </MsalAuthenticationTemplate>
    </MsalProvider>
);

reportWebVitals();

